/** Network accent colors for table / filter dots (prototype). */
export const NETWORK_DOT_COLOR: Record<string, string> = {
  ERC20: '#627EEA',
  BEP20: '#F0B90B',
  TRC20: '#EB0029',
  BTC: '#F7931A',
};

export const getNetworkDotColor = (network: string): string => {
  const key = network.trim().toUpperCase();
  if (NETWORK_DOT_COLOR[key]) return NETWORK_DOT_COLOR[key];
  if (key.includes('TRC') || key.includes('TRON')) return NETWORK_DOT_COLOR.TRC20;
  if (key.includes('BEP') || key.includes('BSC')) return NETWORK_DOT_COLOR.BEP20;
  if (key.includes('ERC') || key.includes('ETH')) return NETWORK_DOT_COLOR.ERC20;
  if (key.includes('BTC')) return NETWORK_DOT_COLOR.BTC;
  return '#9ca3af';
};
